'use client';

import styled from 'styled-components';

import { breakpoints, colors } from '@/styles/theme';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  gap: 8px;
  margin-bottom: 16px;
`;

export const Tag = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  border: 1px solid ${colors.gray3};
  border-radius: 8px;
  padding: 8px 12px;

  font-size: 0.9rem;
  font-weight: 500;
  color: ${({ $active }) => ($active ? colors.light : colors.dark)};
  background-color: ${({ $active }) => ($active ? colors.dark : 'transparent')};
  user-select: none;

  &:hover {
    cursor: ${({ $active }) => ($active ? 'default' : 'pointer')};
    color: ${colors.light};
    background-color: ${colors.dark};
    border-color: ${colors.dark};
  }

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 0.8rem;
  }
`;
